module.exports = __webpack_public_path__ + "fonts/e8218af7de0d29a69b443ed9c788f5a4.svg";